import { render } from "./PrivacyIcon.vue?vue&type=template&id=325e2794&scoped=true"
import script from "./PrivacyIcon.vue?vue&type=script&lang=js"
export * from "./PrivacyIcon.vue?vue&type=script&lang=js"

import "./PrivacyIcon.vue?vue&type=style&index=0&id=325e2794&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325e2794"]])

export default __exports__